import { z } from 'zod';

import { FlagKindSchema } from '../enums';
import { IdSchema } from './common';
import { MemberPublicSchema } from './member';

/** Тихая обратная связь после сбора (BLUEPRINT 2.2.3): три тапа. */
export const FeedbackInputSchema = z.object({
  gatheringId: IdSchema,
  score: z.number().int().min(1).max(5).optional(),
  wouldPlayAgain: z.array(IdSchema).max(16).default([]),
  flag: z
    .object({
      kind: FlagKindSchema,
      userId: IdSchema,
      text: z.string().trim().max(500).optional(),
    })
    .optional(),
});
export type FeedbackInput = z.infer<typeof FeedbackInputSchema>;

/**
 * Что видит участник на `/gathering/:id/feedback` (Stage 9, задача 3): кто был на сборе,
 * кроме него самого, и отправлял ли он уже отзыв. Ответы других участников не показываются
 * никому — флаг уходит только оператору.
 */
export const FeedbackFormSchema = z.object({
  gatheringId: IdSchema,
  squadId: IdSchema,
  index: z.number().int().min(1),
  activityName: z.string(),
  startsAt: z.string().datetime(),
  timezone: z.string(),
  /** Отзыв уже отправлен — форма показывает благодарность */
  submitted: z.boolean(),
  /** Состав сбора без самого себя: у кого спрашиваем «сыграл бы ещё» */
  members: z.array(MemberPublicSchema),
});
export type FeedbackForm = z.infer<typeof FeedbackFormSchema>;

export const FeedbackSubmitResultSchema = z.object({
  feedbackId: IdSchema,
  flagId: IdSchema.nullable(),
});
export type FeedbackSubmitResult = z.infer<typeof FeedbackSubmitResultSchema>;
